import React from 'react';

export const IconIndeterminate = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M12 7H4V9H12V7Z" fill="currentColor" />
  </svg>
);
